import styled from 'styled-components';

export const Wrapper = styled.div`
  height: ${({ theme }): string => theme.spacers!.spacer12};
  width: 100%;
  background-color: ${({ theme }): string => theme.admanColors!.gray.light.bg0[1]};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Divider = styled.span`
  margin: 0 ${({ theme }): string => theme.spacers!.spacer03};
  width: 50px;
  height: 1px;
  background-color: ${({ theme }): string => theme.colors!.colorGray3};
`;
